import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { ComboSociedadesContainer as ComboSociedades} from '../../../components/Combos/Sociedades/container';
import {
  EuiBasicTable,
  EuiIcon,
  EuiFormRow,
  EuiSpacer,
  EuiButton,
  EuiFlexItem,
  EuiFlexGroup,
  EuiFormFieldset,
  EuiSwitch,
  EuiFieldText,
  EuiPanel,
} from '@elastic/eui';
import { stringToFloat } from '../../../../../shared/utils/numbers';
import { HelpTooltip } from './help';
import { useUserSettings } from '../../../context/CurrentUserContext';

export const SocPorcTable = forwardRef((props, ref) => {
  
  const {currentUser}=useUserSettings();
  let {sociedadDefault, sociedades, esIngenieriaProyecto, setError} = props

  let [sociedadesTable,setSociedadesTable] = useState(sociedades)
  let [sociedad, setSociedad] = useState(sociedadDefault)
  let [porcentaje,setPorcentaje] = useState("0")

  useEffect(()=>{
    if(!esIngenieriaProyecto){
      clearIng();
    }
  },[esIngenieriaProyecto])

  useEffect(()=>{
    setError(!sociedadesTable || sociedadesTable.length===0)
  },[sociedadesTable])

  useEffect(()=>{
    setSociedad(sociedadDefault)
  },[sociedadDefault])


  const clearIng = () =>{
    let newData = [];
    let pos = sociedadesTable.findIndex((s) => s.desarrollaIngenieria === true);
    if(pos>-1)
    {
      newData = [ ...sociedadesTable ];
      newData[pos] = {...newData[pos],...{desarrollaIngenieria:false}};
      setSociedadesTable([...newData])
    }
  }

  const checkIng = (data) => {
    let ingSelect = {desarrollaIngenieria:!data.desarrollaIngenieria};
    let newData = [];

    if(ingSelect.desarrollaIngenieria){
      const ingOther = {desarrollaIngenieria:false}
      newData = sociedadesTable.map((s) => {return s.idSociedad === data.idSociedad ? {...s,...ingSelect} : {...s,...ingOther}})
    }else{
      let pos = sociedadesTable.findIndex((s) => s.idSociedad === data.idSociedad);
			newData = [ ...sociedadesTable ];
      newData[pos] = {...data,...ingSelect};
    }

    setSociedadesTable(newData)
  };

  const deleteItem = (id) =>{
    let pos = sociedadesTable.findIndex((o) => o.idSociedad === id);
    let newData = [ ...sociedadesTable ];
    newData.splice(pos, 1);

    setSociedadesTable(newData)
  }

  useImperativeHandle(
    ref,
    () => ({
        getSociedades() {
            return sociedadesTable!==undefined ? sociedadesTable : [];
        }
     })
 )

 const getOnShore = useMemo(()=>{
  let result = 0;
  if(sociedadesTable.length>0){
     sociedadesTable.forEach(s => {
       result+= s.porcentaje;
     });
  }
  return result.toString();
},[sociedadesTable])

//  const getOffShore = useMemo(()=>{
//    let result = 0;
//    if(sociedadesTable.length>0){
//       sociedadesTable.forEach(s => {
//         result+= s.porcentaje;
//       });
//       result = (100-result);
//    }else{result=100}
//    return result.toString();
//  },[sociedadesTable])

 //const getShore = () => `OnShore: ${getOnShore}% / OffShore: ${getOffShore}%`
 const getPorcentaje = () => `Porcentaje: ${getOnShore}%`
  
  const columns = [
    {
      field: 'sociedad',
      name: 'Sociedad',
      sortable: true,
      header: false,
      truncateText: false,
      enlarge: true,
      width: true,
      dataType:"string"
    },
    {
      field: 'porcentaje',
      name: '%',
      sortable: true,
      header: false,
      truncateText: false,
      enlarge: false,
      fullWidth: false,
      dataType:"number"
    },
    {
      field: 'desarrollaIngenieria',
      name: (
          <span>
            Ingeniería{' '}
            <HelpTooltip message="Sociedad que factura la ingeniería" position="top"/>
          </span>
      ),
      sortable: true,
      header: false,
      truncateText: false,
      enlarge: false,
      fullWidth: false,
      dataType:"boolean",
      align:'center',
      render: (desarrollaIngenieria, data) => {
        return <EuiSwitch disabled={!esIngenieriaProyecto} checked={desarrollaIngenieria} onChange={e => checkIng(data)}/>
      }
    },
    {
      name: 'Eliminar',
      align:'center',
      render: (data) => {
        return <EuiIcon type="crossInACircleFilled" color="danger" onClick={()=>deleteItem(data.idSociedad)}/>;
      }
    }
  ];

  const onAgregateSociedad = () =>{
    let socPorc = [{idSociedad:sociedad[0].value, sociedad:sociedad[0].label, porcentaje: stringToFloat(porcentaje), desarrollaIngenieria: false}]

    setSociedadesTable([...sociedadesTable, ...socPorc])
  }

  const getRowProps = (item) => {
    const { id } = item;
    return {
      'data-test-subj': `row-${id}`,
      className: 'customRowClass',
      onClick: () => {},
    };
  };

  const getCellProps = (item, column) => {
    const { id } = item;
    const { field } = column;
    return {
      className: 'customCellClass',
      'data-test-subj': `cell-${id}-${field}`,
      textOnly: true,
    };
  };

  const errorPorcentaje = useMemo(() => {return porcentaje.trim()==="" || (isNaN(stringToFloat(porcentaje)))},[porcentaje])
  const isInvalidSociedad = useMemo(() => {return sociedad===undefined},[sociedad])

  return (
    <EuiFormFieldset legend={{children:getPorcentaje()}} className={getOnShore>100 ? "invalidSocPorcFieldset" : "validSocPorcFieldset"}>
      <EuiFlexGroup gutterSize='s' wrap>
        <EuiFlexItem style={{maxWidth:'50%'}}>
          <EuiFormRow fullWidth label="Sociedades">
            <ComboSociedades compressed fixSociedad = {currentUser.administraUsuarios} fullWidth selectedOptions={sociedad} onChange={value =>{setSociedad(value)}}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem style={{maxWidth:'30%'}}>
          <EuiFormRow label="Porcentaje" isInvalid={errorPorcentaje}>
            <EuiFieldText compressed value={porcentaje} name="txtPorcentaje" onChange={e => setPorcentaje(e.target.value)} isInvalid={errorPorcentaje}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem style={{maxWidth:'20%'}}>
          <EuiFormRow className="btnSocPorcAdd" hasEmptyLabelSpace>
            <EuiButton size='s' fill onClick={onAgregateSociedad} disabled={(isInvalidSociedad || errorPorcentaje)}>Agregar</EuiButton>
          </EuiFormRow>
        </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size="s" />
        <EuiFlexItem>
          {/* <EuiFormRow fullWidth hasEmptyLabelSpace> */}
          <EuiBasicTable
            items={sociedadesTable}
            rowHeader="firstName"
            columns={columns}
            tableLayout='auto'
            rowProps={getRowProps}
            cellProps={getCellProps}
          />
          {/* </EuiFormRow> */}
        </EuiFlexItem>
       </EuiFormFieldset>
  )
});
export default SocPorcTable